var styleDataHash = "30fed54d";
const injectCss = (() => {
  var css = `.BTeX-,.iD7LS{height:386px;margin-right:-16px;margin-top:20px;overflow:auto;padding-right:16px}.BTeX-.PxAQP,.iD7LS.PxAQP{height:calc(100vh - 190px)}.iQBe2{display:flex;flex-direction:column}.Kft59{float:right;text-align:right}.AeY6B{cursor:pointer}.AeY6B:focus-visible{outline:5px auto Highlight!important;outline:5px auto -webkit-focus-ring-color!important}.gAu91{margin-top:50px}.ClLnR,.gAu91{height:100%;width:100%}.BTeX-,.ClLnR,.gAu91{align-items:center;display:flex;justify-content:center}.BTeX-{max-width:100%}.qK3GM{--wds-input-value-font-size-medium:14px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var giphy_selector_default = {
  "giphy_selector_infinite_scroll_container": "iD7LS",
  "giphySelectorErrorContainer": "BTeX-",
  "mobile": "PxAQP",
  "giphy_selector_infinite_scroll": "iQBe2",
  "giphy_selector_powerdByGiphy": "Kft59",
  "giphy_selector_gif_img_container": "AeY6B",
  "giphy_selector_spinner_load_more": "gAu91",
  "giphy_selector_spinner_empty_modal": "ClLnR",
  "searchInput": "qK3GM"
};
export {
  giphy_selector_default as default,
  injectCss
};
//# sourceMappingURL=giphy-selector-scss.js.map
